export default function FAQSection() {
  const faqs = [
    {
      question: '97影院的电影是免费的吗？',
      answer: '是的，97影院所有电影资源均免费提供在线观看。我们致力于为广大影迷提供最新最全的电影资源，无需付费，无需注册，即点即看。',
    },
    {
      question: '97影院的画质怎么样？',
      answer: '97影院提供高清蓝光画质，支持1080P和4K分辨率。我们的视频源经过精心挑选和优化，确保画面清晰、色彩饱满，为您带来影院级的观影体验。',
    },
    {
      question: '观看电影会卡顿吗？',
      answer: '97影院采用全球CDN加速技术，多线路智能切换，确保播放流畅不卡顿。无论您使用电脑、手机还是平板，都能获得丝滑流畅的观影体验。',
    },
    {
      question: '有哪些类型的电影可以看？',
      answer: '97影院涵盖动作片、喜剧片、科幻片、爱情片、恐怖片、动画片、战争片、纪录片等多种类型。无论是最新热播大片还是经典怀旧老片，都能在这里找到。',
    },
    {
      question: '需要下载APP才能观看吗？',
      answer: '不需要！97影院是纯网页端观影平台，无需下载任何APP或插件。您可以直接在浏览器中打开网站，选择喜欢的电影即可开始观看，方便快捷。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              常见<span className="text-primary-500">问题</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-400">关于97影院的常见疑问，这里都有答案</p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden">
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <span className="text-sm md:text-base font-medium text-foreground-100 pr-4">{faq.question}</span>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 group-open:bg-primary-500 group-open:text-foreground-50 transition-all duration-300">
                    <i className="ri-add-line text-sm group-open:hidden"></i>
                    <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                  </span>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}